import { useEffect, useRef } from 'react';

import { analyticsContext, useAnalyticsContext } from './analytics-context';
import { type CanvasAnalyticsWebClient } from './analytics-web-client';

export type ScreenAnalyticsEvent =
  | Parameters<CanvasAnalyticsWebClient['sendScreenEvent']>[0]
  | string;

export const useFireScreenEvent = (rawEvent: ScreenAnalyticsEvent, shouldFire = true) => {
  const { client } = useAnalyticsContext();
  const sent = useRef(false);

  useEffect(() => {
    if (!sent.current && shouldFire) {
      sent.current = true;
      fireScreenEvent(rawEvent, client);
    } else if (sent.current && !shouldFire) {
      sent.current = false;
    }
  }, [client, rawEvent, shouldFire]);
};

export const fireScreenEvent = async (
  rawEvent: ScreenAnalyticsEvent,
  client = analyticsContext.client,
) => {
  if (!client) {
    return;
  }

  const event = typeof rawEvent === 'string' ? { name: rawEvent } : rawEvent;
  event.attributes = { ...event.attributes };

  try {
    await client.sendScreenEvent(event);
  } catch (e) {
    console.error(e);
  }
};
